import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Api } from "../api/baseApi";
import { useEffect, useState } from "react";

const FooterOne = () => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [resultMessage, setResultMessage] = useState(null);
  const moveHomeClick = (event, href) => {
    event.preventDefault();
    if (location.pathname !== `/${i18n.language}`) {
      navigate(`/${i18n.language}`, { replace: false });
      setTimeout(() => {
        const element = document.querySelector(href);
        if (element) element.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      const element = document.querySelector(href);
      if (element) element.scrollIntoView({ behavior: "smooth" });
    }
  };

  // API request
  const sendSubscribeMessage = async (contactData) => {
    const { data } = await Api.post(`/api/subscribe`, contactData);
    return data;
  };

  // Formik + Yup schema
  const initialValues = { email: "", project: "Payways" };
  const validationSchema = Yup.object({
    email: Yup.string()
      .email(t("footerOne.errors.0") || "Invalid email")
      .required(t("footerOne.errors.1") || "Email is required"),
  });

  const handleSubmit = async (values, { resetForm }) => {
    try {
      const response = await sendSubscribeMessage(values);
      if (response.status) {
        setResultMessage({
          status: true,
          message: t("errorMessages.0"),
        });
      }
    } catch (error) {
      if (error) {
        setResultMessage({
          status: false,
          message: t("errorMessages.1"),
        });
      }
    }

    resetForm();
  };

  useEffect(() => {
    if (resultMessage) {
      setTimeout(() => {
        setResultMessage(null);
      }, 5000);
    }
  }, [resultMessage]);

  return (
    <>
      <footer className="footer-section">
        <div className="footer-content">
          <div className="container container-two">
            <div className="row gy-5">
              <div className="col-xl-3 col-sm-6">
                <div className="footer-widget">
                  <div className="footer-widget__logo">
                    <Link to={`/${i18n.language}`}>
                      <img
                        src="/assets/images/logo/logo-all-white.png"
                        alt=""
                      />
                    </Link>
                  </div>
                  <p className="footer-widget__desc">
                    {t("footerOne.logoText")}
                  </p>
                </div>
              </div>

              <div className="col-xl-3 col-sm-6 col-xs-6 ps-xl-5">
                <div className="footer-widget">
                  <h5 className="footer-widget__title text-white">
                    {t("footerOne.quickLinks")}
                  </h5>
                  <ul className="footer-lists">
                    <li className="footer-lists__item">
                      <a
                        className="footer-lists__link"
                        href="#about"
                        onClick={(event) => moveHomeClick(event, "#about")}
                      >
                        {t("about")}
                      </a>
                    </li>
                    <li className="footer-lists__item">
                      <a
                        className="footer-lists__link"
                        href="#solutions"
                        onClick={(event) => moveHomeClick(event, "#solutions")}
                      >
                        {t("solutions")}
                      </a>
                    </li>
                    <li className="footer-lists__item">
                      <NavLink
                        to={`/${i18n.language}/contact`}
                        className="footer-lists__link"
                      >
                        {t("contact")}
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-xl-4 col-sm-6">
                <div className="footer-widget">
                  <h5 className="footer-widget__title text-white">
                    {t("footerOne.subscribeTitle")}
                  </h5>
                  <p className="footer-widget__desc">
                    {t("footerOne.subscribeDesc")}
                  </p>

                  {resultMessage && (
                    <div
                      style={{ color: resultMessage?.status ? "green" : "red" }}
                      role="alert"
                    >
                      {resultMessage?.message}
                    </div>
                  )}

                  {/* Formik Form */}
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                  >
                    {({ isSubmitting }) => (
                      <Form className="mt-4 subscribe-box d-flex  flex-column gap-2">
                        <Field
                          type="email"
                          name="email"
                          className="form-control common-input-white pill text-white"
                          placeholder={t("footerOne.subscribePlaceholder")}
                        />
                        <ErrorMessage
                          name="email"
                          component="div"
                          className="text-danger font-14"
                        />

                        <button
                          id="subscribe-button"
                          type="submit"
                          className="btn-lg w-100 pill"
                          disabled={isSubmitting}
                        >
                          {t("footerOne.subscribeBtn")}
                        </button>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* bottom Footer */}
      <div className="bottom-footer">
        <div className="container container-two">
          <div className="bottom-footer__inner flx-between gap-3">
            <p className="bottom-footer__text font-14">
              {t("footerOne.copyright.0")}
            </p>
            <div className="footer-links">
              {/* <Link
                to={"https://itresources.io/en/privacy-policy"}
                className="footer-link font-14"
              >
                {t("footerOne.copyright.2")}
              </Link> */}
              <div className="d-flex gap-2">
                <span className="footer-link font-14">
                  {t("footerOne.we_accept")}:
                </span>
                <div className="d-flex gap-2">
                  <img
                    className="m-left-6"
                    src="/assets/images/cards/MasterCard.svg"
                    alt="MasterCard"
                    width={35}
                  />
                  <img
                    className="m-left-6"
                    src="/assets/images/cards/Visa.svg"
                    alt="Visa"
                    width={35}
                  />
                  <img
                    className="m-left-6"
                    src="/assets/images/cards/Arca.svg"
                    alt="Arca"
                    width={35}
                  />
                  <img
                    className="m-left-6"
                    src="/assets/images/cards/AMEX.svg"
                    alt="AMEX"
                    width={35}
                  />
                  <img
                    className="m-left-6"
                    src="/assets/images/cards/idram.png"
                    alt="idram"
                    width={35}
                    style={{objectFit: 'contain'}}
                  />
                </div>
              </div>
              <Link
                id="privacy-policy"
                to={`/${i18n.language}/privacy-policy`}
                className="footer-link font-14"
              >
                {t("footerOne.copyright.2")}
              </Link>
              <Link
                id="privacy-policy"
                to={`/${i18n.language}/terms-and-conditions`}
                className="footer-link font-14"
              >
                {t("footerOne.copyright.4")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FooterOne;
